/// <reference path='../_all.ts' />

module tabs {
  'use strict';

  /**
   *
   */
  tabTitle.$inject = [
    '$timeout', 
    '$window', 
    'anchorNavService', 
    'pageMetaService', 
    'parallaxService', 
    'debounce',
  ];
  export function tabTitle(
    $timeout :ng.ITimeoutService
    , $window : ng.IWindowService
    , anchorNavService : navigation.IAnchorNavService
    , pageMetaService: navigation.IPageMetaService
    , parallaxService : navigation.IParallaxService
    , debounce:  navigation.IDebounceService): ng.IDirective {
    
    return {
      restrict: 'A',
      transclude: true,
      scope: {
        pageId: '@',
        routeId: '@',
        navKey: '@',
      },
      require: '^tabs',      
      link: function (scope : ITabPageScope, element : ng.IAugmentedJQuery, attr, controller : TabCtrl, transclude : ng.ITranscludeFunction) {
        scope.meta = pageMetaService.getPageMeta;
        scope.nav = anchorNavService; 

        transclude(scope, function(clone) {
         element.append(clone);
        });

        scope.t = controller.registerTitle(element, scope.pageId, scope.routeId, scope.navKey);

        scope.t.title.setActiveFunction = (active : boolean) => {
          scope.active = active;
        };

        scope.toggleActive = (event : ng.IAngularEvent) =>  {
          if (event) event.preventDefault();
          controller.toggleActive(scope.t);

          if (scope.t.isActive) {
            if (scope.t.navItem) anchorNavService.setActive(scope.t.navItem);
          } else {
            $(element).children("a").blur();
            if (scope.t.navItem) anchorNavService.setInactive(scope.t.navItem);
          }
        }
      }
    }
  }
}